/**
 *
 * @constructor
 */
function GoogleAuthenticationController() {
    /*Google btn**/
    this.$googleBtn = $('.googleLogin');
    this.GoogleAuth = null;
}

GoogleAuthenticationController.prototype.init = function () {
    this.loadGoogleApis();
};

GoogleAuthenticationController.prototype.loadGoogleApis = function () {
    var that = this;
    $.when(
        $.getScript( "https://apis.google.com/js/api.js"),
        $.Deferred(function( deferred ){
            $( deferred.resolve );
        })
    ).done(function(){
        that.startLoadApiClient();
    });
};


GoogleAuthenticationController.prototype.makeAuthenticationWithGoogleAccount = function (profile, authdata) {
    //var that = new RegistrationComponent();

    try {
        var jsonauth = JSON.stringify(authdata);
    }catch(err) {
        var jsonauth = {error:true}
    }


    let registrationInfo ={
        lname: '',
        fname: profile.getName(),
        email: profile.getEmail(),
        password: profile.getId(),
        googleClientId: profile.getId(),
        isGoogleLogin: true,
        withtoken: 0,
        withoutlname: 1,
        logintype: 1,
        clientid: profile.getId(),
        authobj: jsonauth,
        aszfon: true,
        withtoken: true,
    };

    try {
        registrationInfo = JSON.stringify(registrationInfo);
    }catch (err) {
        registrationInfo = {fname: null}
    }

    sessionStorage.setItem('RegistrationInfo', registrationInfo);

    try {
        grecaptcha.execute();
    }catch (err) {

    }


};

GoogleAuthenticationController.prototype.handleGoogleLoginBtnClick = function () {
    var that = this;
    this.$googleBtn.on('click', function (e) {
        e.preventDefault();
        that.GoogleAuth.signIn()
            .then(function(response) {
                console.log(response);
                var profile = that.GoogleAuth.currentUser.get().getBasicProfile();
                var authdata = that.GoogleAuth.currentUser.get().getAuthResponse(true);
                that.makeAuthenticationWithGoogleAccount(profile, authdata);
            })
            .catch(function(err) {
                console.log('error.google.authentication', err);
            });
    });
};

GoogleAuthenticationController.prototype.GAPIClientInit = function () {
    var self = new GoogleAuthenticationController();

    gapi.client.init({
        'apiKey': 'AIzaSyCEbkLameJXP3l35zcQRpfiKcQfdI1zwA4',
        'clientId': '349247160836-jo0elju3uj0to34akmijng09dr1050iv.apps.googleusercontent.com',
        'cookiepolicy': 'single_host_origin',
        'scope': 'profile'
    }).then(function() {
        self.GoogleAuth = gapi.auth2.getAuthInstance();
        if(self.GoogleAuth.currentUser.get().isSignedIn) {
            self.GoogleAuth.currentUser.get().disconnect();
        }
        //&& self.GoogleAuth.currentUser.get().hasGrantedScopes('https://www.googleapis.com/auth/userinfo.profile')
        //self.makeAuthenticationWithGoogleAccount(self.GoogleAuth.currentUser.get().getBasicProfile());
        self.handleGoogleLoginBtnClick();
        return true;
    }).then(function(response) {

    }, function(reason) {
       console.log('google.auth.error', reason)
    });

};

GoogleAuthenticationController.prototype.startLoadApiClient = function () {

    try{
        gapi.load('client', this.GAPIClientInit);
    }catch (err) {
        console.log("Error start client loading");
    }

};

module.exports = GoogleAuthenticationController;
